<div class="ttmodal" *ngIf="isCopied">
  <div class="ttmodal__header">
      <span class="ttmodal__title">Confirmation</span>
      <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
  </div>
  <div class="ttmodal__body" >
      
          <span class="label">This question is currently linked to a parent Question that it was copied from. This link allows these questions to be compared historically across different forms. If you save your changes this link will be removed.</span>
          
          
     
  </div>

  <div class="ttmodal__footer" >
      <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
      <a class="button button--primary" (click)="Update()"><span class="button__text">Save</span></a>
  </div>
</div>


<div class="ttmodal" *ngIf="isParent">
  <div class="ttmodal__header">
      <span class="ttmodal__title">Confirmation</span>
      <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
  </div>
  <div class="ttmodal__body"  style="display: flex;flex-direction: column;">
      
          <span class="label">This question has been copied and is the parent question for those copies. Do you wish to update all the copies of this questions? </span>
          <span class="label">If you select Yes, all copies will be updated. </span>
          <span class="label">If you select No, this question will be updated and the copies will be un-linked from this question. Once un-linked, the questions cannot be compared historically across multiple forms.</span>
          <span class="label">If you select Cancel your changes will not be saved.</span>

  </div>

  <div class="ttmodal__footer" >
      <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
      <a class="button button--primary" (click)="UpdateYes()"><span class="button__text">Yes</span></a>
      <a class="button button--primary" (click)="UpdateNo()"><span class="button__text">No</span></a>

  </div>
</div>

<div class="ttmodal" *ngIf="isDelete">
  <div class="ttmodal__header">
      <span class="ttmodal__title">Confirmation</span>
      <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
  </div>
  <div class="ttmodal__body"  style="display: flex;flex-direction: column;">
      
         <span class="label">Are you sure you want to delete this {{value}}. </span>

  </div>

  <div class="ttmodal__footer" >
      <a class="button button--primary" (click)="DeleteYes()"><span class="button__text">Yes</span></a>
      <!-- <a class="button button--primary" (click)="DeleteNo()"><span class="button__text">No</span></a> -->
      <a class="button margin-right-8" (click)="DeleteNo()"><span class="button__text">No</span></a>

  </div>
</div>